import { gql } from '@apollo/client';

export const createEvent = gql`
  mutation CreateEvent($input: CreateEventInput!) {
    createEvent(input: $input)
  }
`;
